export default __webpack_public_path__ + "static/media/correct.7fa6a873.gif";